import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { HttpService, LincesCommonModule, LoginService } from '@docpath/linces-angular-components/common';
import { DpAppSwitcherModule, DpErrorPagesModule, DpFormModule, DpLeftmenuModule, DpLoginModule, DpMainViewModule, DpModalModule, DpToastModule } from '@docpath/webcomponents';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { CloudComponent } from './pages/cloud/cloud.component';
import { ConfigurationModule } from './pages/configuration/configuration.module';
import { HomeModule } from './pages/home/home.module';
import { LoginComponent } from './pages/login/login.component';
import { MonitoringModule } from './pages/monitoring/monitoring.module';
import { StatisticsModule } from './pages/statistics/statistics.module';
import { AppService } from './shared/services/app.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    CloudComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    CommonModule,
    LincesCommonModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => localStorage.getItem('access_token')
      }
    }),
    AppRoutingModule,
    ConfigurationModule,
    DpLoginModule,
    DpLeftmenuModule,
    DpErrorPagesModule,
    DpFormModule,
    DpModalModule,
    DpAppSwitcherModule,
    DpToastModule,
    HomeModule,
    StatisticsModule,
    MonitoringModule,
    DpMainViewModule,
    NgbTooltipModule,
    FontAwesomeModule,
    TranslateModule
  ],
  providers: [
    LoginService,
    HttpService,
    AppService,
    {
      provide: 'environment', useValue: {
        accessControlApiPath: environment.ACCESS_CONTROL_API_PATH,
        appName: environment.APP_NAME,
        baseUrl: environment.BASE_URL,
        cookieName: environment.COOKIE_NAME,
        webApiPath: environment.WEB_API_PATH
      }
    },
    { provide: 'appName', useValue: environment.APP_NAME }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far);
  }
}